<template>
  <fragment>
    <v-app-bar
      v-scroll="handleScroll"
      :class="{ fixed: fixed }"
      class="header"
      fixed
      dense
      app
      height="auto"
    >
      <v-container>
        <div class="header-content mx-3">
          <nav class="nav-menu">
            <div class="logo">
              <router-link :to="localePath(to)">
                <logo type="landscape" :name="$t('brand.name')" />
              </router-link>
            </div>
          </nav>
          <nav>
            <v-btn href="https://app.motanamy.com" text>{{ $t('header.login') }}</v-btn>
            <v-spacer class="vertical-divider" />
            <setting-menu />
          </nav>
        </div>
      </v-container>
    </v-app-bar>
  </fragment>
</template>

<style lang="scss" scoped>
@import "./header-style.scss";
</style>

<script>
import Logo from "../Logo";
import Settings from "./TopNav/Settings";

export default {
  components: {
    Logo,
    "setting-menu": Settings
  },
  data() {
    return {
      fixed: false,
      loaded: false
    };
  },
  mounted() {
    this.loaded = true;
  },
  props: {
    to: {
      type: String,
      default: () => "/"
    }
  },
  methods: {
    handleScroll: function() {
      if (window.scrollY > 100) {
        return (this.fixed = true);
      }
      return (this.fixed = false);
    }
  },
  computed: {
    isDesktop() {
      const lgUp = this.$store.state.breakpoints.lgUp;
      return lgUp.indexOf(this.$mq) > -1;
    }
  }
};
</script>
